import translations from '../translations/pl.json';

export default () => input => {
  return translations[input] || '';
};
